'use strict';

require('./src/tr-trustpass');
module.exports = 'trTrustpass';
